var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('vuestic-widget',{staticClass:"no-padding no-v-padding breadcrumbs"},[_c('vuestic-breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs,"current-path":_vm.currentRoute}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }